export default __webpack_public_path__ + "static/media/avatar-edu.ef699173.webp";